import * as React from 'react';

function SvgIconMediaVolume(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" {...props}>
      <path
        d="M18.61 4.379a1.073 1.073 0 00-1.116.1l-8.249 6.188H4.267c-.59 0-1.067.476-1.067 1.066v8.534c0 .59.477 1.066 1.067 1.066h4.978l8.249 6.187a1.061 1.061 0 001.116.101c.362-.181.59-.55.59-.954V5.333c0-.404-.228-.773-.59-.954zM28.8 14.933h-6.4v2.133h6.4v-2.133zM26.124 7.077l-5.543 3.2 1.066 1.847 5.543-3.2-1.066-1.847zM21.647 19.877l-1.067 1.847 5.543 3.2 1.066-1.847-5.542-3.2z"
        fill="currentColor"
      />
    </svg>
  );
}

export const IconMediaVolume = React.memo(SvgIconMediaVolume);
